import React from 'react'
import clsx from 'clsx'
import Link from 'components/Link'
import Typography from 'components/Typography'
import { values, defaultPageTitle } from 'appConstants'
import SEOHelmet from 'containers/AppPage/components/SEOHelmet'
import { route } from 'routes'
import FooterGeneral from 'components/Footer/FooterGeneral'
import Page from 'components/Page'
import stylesGlobal from 'stylesGlobal.module.scss'
import styles from './NotFoundPage.module.scss'

const NotFoundPage: React.FC = () => {
  return (
    <Page>
      <div
        className={clsx(
          stylesGlobal.FlexAuto,
          stylesGlobal.Height1,
          stylesGlobal.WidthFull,
          stylesGlobal.MarginXAuto,
          stylesGlobal.Container
        )}
      >
        <SEOHelmet title={`Page Not Found  | ${defaultPageTitle}`} />

        <div className={styles.NotFoundPage}>
          <Typography variant="h3" fontWeight="extraBold" className={stylesGlobal.MarginBottom44}>
            Page not found
          </Typography>

          <Typography variant="h5" className={styles.MainParagraph}>
            We can’t seem to find the page you’re looking for. Please go back to the{' '}
            <Link color="secondary" to={route.ROOT.getUrl()}>
              <Typography variant="h5" component="span" fontWeight="extraBold">
                Homepage
              </Typography>
            </Link>{' '}
            or contact us at{' '}
            <Link
              color="secondary"
              target="_blank"
              rel="noreferrer"
              href={`mailto:${values.PLAYFORM_SUPPORT_EMAIL}`}
            >
              <Typography variant="h5" component="span" fontWeight="extraBold">
                support@playform.io
              </Typography>
            </Link>
          </Typography>
        </div>
      </div>

      <FooterGeneral />
    </Page>
  )
}

export default NotFoundPage
